var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-tooltip",class:{ active: !_vm.disabled }},[_c('div',{staticClass:"inner"},[_vm._t("default")],2),_c('div',{staticClass:"tip",class:_vm.placement},[_vm._v(" "+_vm._s(_vm.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }